import { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';

import useApp from 'hooks/useApp';
import useApi from 'hooks/useApi';
import useLocalStore from 'hooks/useLocalStore';

export const TokenInfo = (data) => {
	const localStore = useLocalStore();
	const app = useApp();
	const api = useApi();
	const { empid, setempid } = useApp();
	const [token, setToken] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [empresaInfo, setEmpresaInfo] = useState(null);
	const [texto, setTexto] = useState('Clique no botão abaixo para gerar um token de acesso.');
	const toast = useRef(null);

	const empresaInfoRequest = () => {
		if (!empresaInfo)
			setEmpresaInfo(data.data)
	}

	const TokenGenerate = async () => {
		setIsLoading(true);
		setTexto("Gerando token...");

		let formPost = {
			id: 0,
			empId: empresaInfo.id
		};

		let json = JSON.stringify(formPost);

		try {
			let response = await api.post("/Auth/TokenGenerator", json);
			setToken(response.data);
			setTexto("Token gerado com sucesso! Copie e utilize-o conforme necessário.");
			toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Token gerado com sucesso!', life: 3000 });
		} catch (error) {
			setTexto("Falha ao gerar o token. Tente novamente.");
			toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao gerar o token.', life: 3000 });
		} finally {
			setIsLoading(false);
		}
	}

	const copy = (tk) => {
		navigator.clipboard.writeText(tk).then(() => {
			toast.current.show({ severity: 'info', summary: 'Copiado', detail: 'Token copiado para a área de transferência!', life: 3000 });
		}).catch(err => {
			console.error("Falha ao copiar o texto: ", err);
			toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao copiar o token.', life: 3000 });
		});
	}

	return (
		<div className="p-4 flex justify-content-center align-items-center">
			<Toast ref={toast} />
			<Card title="Gerar Token de Acesso" className="w-6 shadow-3">
				<p className="text-center text-lg mb-4">{texto}</p>
				{empresaInfoRequest()}
				{empresaInfo &&
					<div className="mb-4">
						<Divider />
						<div className="text-center">
							<h4 className="text-primary">{empresaInfo.razaosocial}</h4>
						</div>
						<Divider />
					</div>
				}

				<div className="mb-4">
					<InputTextarea
						value={token}
						className="w-full text-center text-lg"
						rows={3}
						readOnly
						placeholder="O token será exibido aqui."
					/>
				</div>

				<div className="flex justify-content-between">
					<Button
						className="p-button-outlined p-button-info"
						disabled={!token}
						onClick={() => copy(token)}
						icon="pi pi-copy"
						label="Copiar Token"
					/>
					<Button
						className="p-button-success"
						onClick={TokenGenerate}
						icon="pi pi-key"
						label="Gerar Token"
						disabled={isLoading}
					/>
				</div>

				{isLoading && (
					<div className="mt-4 text-center">
						<ProgressSpinner />
					</div>
				)}
			</Card>
		</div>
	);
}